import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";
import { Link } from "react-router-dom";
import View from "./View";
import PiView from "./PiView";
import PreChallan from "./PreChallan";
import PostChallan from "./PostChallan";
import MarketingChallan from "./MarketingChallan";

function AllChallans(props) {
  const [defaultTab, setDefaultTab] = useState("pre");
  const [isPreChallan, setIsPreChallan] = useState(false);
  const [isPostChallan, setIsPostChallan] = useState(false);
  const [isMarketingChallan, setIsMarketingChallan] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const checkUserRoleById = (roleId) => {
    return (
      userProfile?.user_role.filter((role) => parseInt(role.id) === roleId)
        .length ?? false
    );
  };

  const isSalesExecutive = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Executive_permissions"
  );
  const isSalesCoordinator = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Coordinator_permissions"
  );
  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Regional_Sales_Manager_permissions"
  );
  const isStoreManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Store_Manager_permissions"
  );
  const isCeo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Executive_Officer_permissions"
  );
  const isCfo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Financial_Officer_permissions"
  );
  const isBrandManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Brand_Manager_permissions"
  );
  const isLogisticManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Logistic_Department_permissions"
  );

  // const isSalesExecutive = checkUserRoleById(22) // Sales Executive
  // const isSalesCoordinator = checkUserRoleById(9) // Sales Co-Ordinator
  // const isRsm = checkUserRoleById(13); //Regional Sales Manager"
  // const isStoreManager = checkUserRoleById(29); //Store Manager
  // const isCeo = checkUserRoleById(27); // Chief Executive Officer
  // const isCfo = checkUserRoleById(30); // Chief Financial Officer
  // const isBrandManager = checkUserRoleById(28); // Brand Manager
  // const isLogisticManager = checkUserRoleById(6); // Logistic Department

  useEffect(() => {
    let orderStatus = parseInt(props.rowData?.order_status);
    if (isNaN(orderStatus) && props.rowData?.orderdata) {
      orderStatus = parseInt(props.rowData?.orderdata?.order_status);
    }

    if (
      (isSalesCoordinator || isStoreManager) &&
      orderStatus >= 23 &&
      utils.hasPermission(
        primaryMenuRes,
        "Sales Order",
        "sales_order.pre_challan"
      )
    ) {
      setIsPreChallan(true);
    }

    if (
      (isSalesCoordinator || isLogisticManager) &&
      orderStatus >= 27 &&
      utils.hasPermission(
        primaryMenuRes,
        "Sales Order",
        "sales_order.post_challan"
      ) &&
      props?.rowData?.pi_response?.post_challan_status === "1"
    ) {
      setIsPostChallan(true);
    }

    if (
      (isSalesCoordinator || isBrandManager) &&
      orderStatus >= 24 &&
      utils.hasPermission(
        primaryMenuRes,
        "Sales Order",
        "sales_order.marketing_challan"
      ) &&
      props?.rowData?.pi_response?.brand_manager_material_status === "1"
    ) {
      setIsMarketingChallan(true);
    }
  }, [props.rowData]);

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handlePropsChange = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        {/*<RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>*/}
        <RB.Card.Body>
          <RB.Tabs
            activeKey={defaultTab}
            onSelect={(k) => setDefaultTab(k)}
            variant={"underline"}
            className={"border-bottom"}
          >
            {isPreChallan && (
              <RB.Tab title={"Pre Challan"} eventKey={"pre"}>
                <PreChallan
                  comp={"PreChallan"}
                  rowData={props.rowData}
                  onChange={handlePropsChange}
                />
              </RB.Tab>
            )}
            {isPostChallan && (
              <RB.Tab title={"Post Challan"} eventKey={"post"}>
                <PostChallan
                  comp={"PiView"}
                  rowData={props.rowData}
                  onChange={handlePropsChange}
                />
              </RB.Tab>
            )}
            {isMarketingChallan && (
              <RB.Tab title={"Marketing Challan"} eventKey={"marketing"}>
                <MarketingChallan
                  comp={"MarketingChallan"}
                  rowData={props.rowData}
                  onChange={handlePropsChange}
                />
              </RB.Tab>
            )}
          </RB.Tabs>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default AllChallans;
